class SinaiTabs {
    constructor() {
        console.log("HI");
        var tabs = $(".wp-block-ub-tabbed-content-tabs-title");
        if ($(tabs).length) {
            $(tabs).each((i, el) => {
                var tabChildren = $(el).children(".wp-block-ub-tabbed-content-tab-title-wrap");
                this.setupTabContainer(tabChildren)
            });
        }
    }

    setupTabContainer(tabs) {
        var angleLeft = '<i class="fas fa-angle-left d-block d-md-none"></i>';
        var angleRight = '<i class="fas fa-angle-right d-block d-md-none"></i>';
        $(tabs).each((i, el) => {
            var btnLeft = $(angleLeft).prependTo(el);
            var btnRight = $(angleRight).appendTo(el);
            var prev = i == 0 ? tabs[tabs.length - 1] : tabs[i - 1];
            var next = i == (tabs.length - 1) ? tabs[0] : tabs[i + 1];
            $(btnLeft).on('click', (ev) => {
                $(prev).focus();
            });
            $(btnRight).on('click', (ev) => {
                $(next).focus();
            });
        });
    }
}

export default SinaiTabs;